window.quick_buy_test = false;
async function quickBuy() {
  const allBrandLi = document.querySelectorAll(".collection-li");
  const quickBuyWrapper = document.querySelector(".quickBuyWrapper");
  const genericPPSuffix = quickBuyWrapper.dataset.genericProductPageSuccessor;
  const socketPrefix = quickBuyWrapper.dataset.socketPrefix;
  const main = document.querySelector(".quickBuyWrapper main");
  const sideBar = document.querySelector(".quickBuyWrapper #sideBar");
  const viewAllBrands = document.querySelector(".viewAllBrands");
  const viewAllBrandsSpan = document.querySelector(".viewAllBrandsSpan");
  const loadingWrapperParent = document.querySelector(".loadingWrapperParent");
  const quickBuyAtc = document.querySelector("#quickBuyAtc");
  const productPrice = quickBuyWrapper.dataset.productPrice;
  const shouldCheckSpecialPP =
    quickBuyWrapper.dataset.shouldCheckSpecialPp === "true";
  const fetchUrl =
    document.querySelector(".quickBuyWrapper").dataset.marketDataJsonUrl;
  const makeModelJsonUrl = fetchUrl
    .replace("_market", "_makeModel")
    .split("?")[0];
  const marketData = await fetch(fetchUrl).then((res) => res.json());
  window.makeModelArr = await getMakeModelJSON(makeModelJsonUrl);
  const variantOverlayPreceder = quickBuyWrapper.dataset.variantOverlayPreceder;
  const goToPP = quickBuyWrapper.dataset.goToPp;
  const buttonText = quickBuyWrapper.dataset.buttonText;

  allBrandLi.forEach((brandLi) => {
    brandLi.addEventListener("click", (e) => {
      const clickedBrand = e.target.textContent;
      sideBar.style.display = "none";
      loadingWrapperParent.style.display = "flex";
      fetchProductsForBrand(clickedBrand);
    });
  });
  const fetchProductsForBrand = (brandName) => {
    const data = marketData.find(
      (item) => item.make.toLowerCase() === brandName.trim().toLowerCase()
    );
    // console.log("data ------->", data);
    // console.log(marketData);
    if (!data) return console.error("could not find the make");
    const products = data.models;
    // console.log("products ----->", products);

    quickBuyWrapper.style.backgroundImage = "none";
    quickBuyWrapper.style.backgroundColor = "#212121";

    const scrollTop = { top: 100, behavior: "smooth" };

    window.scrollTo(scrollTop);
    loadingWrapperParent.style.display = "none";
    main.style.display = "grid";
    viewAllBrands.style.display = "flex";
    viewAllBrandsSpan.addEventListener("click", () => {
      main.style.display = "none";
      sideBar.style.display = "grid";
      viewAllBrands.style.display = "none";

      defaultBgImage();
    });

    displayProducts(data.make, products);
  };

  const displayProducts = (make, products) => {
    main.innerHTML = "";

    // render product cards
    products.forEach((product) => {
      const productHTML = `<div class="product-card-body">
        <span class="addedProduct">ADDED</span>
        <div class="product-card-imgParent">
          <img width="300" height="300" loading="lazy" src="https://cdn.shopify.com/s/files/1/0050/1068/6042/files/1_pc_unit_product_a9e53c91-b1fd-4a3e-9e44-9f751d9ba00a.png?v=1713913350">
          <span class="product-card-price">${productPrice}</span>
          <span class="product-card-make-model">${variantOverlayPreceder} ${make.toUpperCase()} ${product.model.toUpperCase()}</span>
        </div>
        <button class="product-card-view-variants">  ${buttonText} </button>
        <ol class="product-card-variantsParent">
          ${product.variants
            .filter((variant) => !variant.socket.includes("PC00"))
            .reverse()
            .map((variant) => {
              const socketCode = socketPrefix
                ? `${socketPrefix}-${
                    (variant.socket.match(/PC\d+/) || [])[0] || ""
                  }`
                : variant.socket;

              return `
            <li>
              <button class="c-btn-add-to-cart atcBtnDrawer" data-pc-code="${socketCode}" data-selection="${make} / ${product.model} / ${variant.body} / ${variant["engine-volume"]}">
                <span class="variantYear">${variant.body}</span> 
                <span class="variantEngine">${variant["engine-volume"]}</span>
              </button>
            </li>
          `;
            })
            .join("")}
        </ol>
        <a class="product-card-goTo" href="javascript:void(0);" data-model="${
          product.model
        }" data-make="${make}"> ${goToPP} </a>
      </div>`;
      main.innerHTML += productHTML;
    });
    // hpValues
    // show variants
    const buttons = document.querySelectorAll(".product-card-view-variants");
    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        const variantsList = this.nextElementSibling;
        variantsList.style.display =
          variantsList.style.display === "flex" ? "none" : "flex";
        if (variantsList.childElementCount < 7) {
          variantsList.style.justifyContent = "center";
        }
      });
    });
    const goToProductPageButtons =
      document.querySelectorAll(".product-card-goTo");
    goToProductPageButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        const genericPPUrl = `${window.Shopify.routes.root}products/pedal-commander-${genericPPSuffix}`;
        window.localStorage.setItem(
          "hpValues",
          JSON.stringify({
            make: button.dataset.make,
            model: button.dataset.model,
          })
        );
        if (!shouldCheckSpecialPP) {
          window.location.href = genericPPUrl;
          return;
        }

        const specialProducts = window.makeModelArr?.find(
          (item) => item.make === button.dataset.make
        )?.specialProductPage;
        if (
          !specialProducts?.includes(
            `${button.dataset.make} ${button.dataset.model}`
          )
        ) {
          window.location.href = genericPPUrl;
          return;
        }

        const productUrl = `${
          window.Shopify.routes.root
        }products/${encodeURIComponent(
          `${button.dataset.make}-${button.dataset.model}`
        )}`.toLowerCase();
        fetch(productUrl)
          .then((res) => {
            if (res.status === 404) {
              window.location.href = genericPPUrl;
              return;
            }
            window.location.href = productUrl;
          })
          .catch((err) => {});
      });
    });

    const allLiElement = document.querySelectorAll(
      ".product-card-variantsParent li"
    );

    allLiElement.forEach((li, index) => {
      li.addEventListener("click", async function (event) {
        const buttonElement = li.querySelector("button");
        const productData = await fetch(
          `${window.Shopify.routes.root}products/${buttonElement.dataset.pcCode}.js`
        ).then((res) => res.json());
        const id = productData.variants[0].id;
        const selection = buttonElement.dataset.selection;

        const addedProduct = event.target
          .closest(".product-card-body")
          .querySelector(".addedProduct");

        if (addedProduct) {
          addedProduct.style.display = "flex";
          setTimeout(() => {
            addedProduct.style.display = "none";
          }, 2000);
        }

        if (!window.quick_buy_test) {
          defaultBgImage();
          event.target.closest(".product-card-variantsParent").style.display =
            "none";
          setTimeout(() => {
            main.style.display = "none";
            sideBar.style.display = "grid";
            viewAllBrands.style.display = "none";
          }, 2000);
        }

        quickBuyAtc.dataset.atc = id;
        quickBuyAtc.dataset.selection = selection;
        quickBuyAtc.click();
        if (window.quick_buy_test) {
          li.style.background = "#f00";
        }
      });
    });
  };

  function defaultBgImage() {
    quickBuyWrapper.style.backgroundColor = "none";
    if (window.innerWidth > 768) {
      quickBuyWrapper.style.backgroundImage =
        "url('//pedalcommander.com/cdn/shop/t/187/assets/xd-hero_bg.webp')";
    } else {
      quickBuyWrapper.style.backgroundImage =
        "url('//pedalcommander.com/cdn/shop/t/163/assets/xd-hero-mobile_bg.webp')";
    }
  }

  async function getMakeModelJSON(url) {
    if (!shouldCheckSpecialPP) return null;
    const response = await fetch(url)
      .then((res) => res.json())
      .catch((err) => {
        console.error(err);
      });
    return response.createdMakeModel;
  }
}

document.addEventListener("DOMContentLoaded", quickBuy);
